function isNight () {
  // Real check if not overridden
  let d = new Date()
  let h = d.getHours()
  return (h >= 18 || h < 9)
}

export default isNight
